/* eslint-disable func-names */
/* eslint-disable import/no-unresolved, import/extensions */
import React from 'react';
import PropTypes from 'prop-types';
import OriginalForm from 'react-jsonschema-form';
import SchemaField from 'react-jsonschema-form/lib/components/fields/SchemaField';
import Markdown from 'markdown-to-jsx';
import BaseWidgets from './components/widgets';
import BaseFields from './components/fields';
import BaseFieldTemplate from './components/FieldTemplate';
import CustomTitleField from './components/fields/CustomTitleField';
import CustomObjectFieldTemplate from './components/CustomObjectFieldTemplate';
import { getPages, isFormPaginated, isFormChatUI, getAllElementKeys } from './logic';
import './style.css';

const CustomSchemaField = function (props) {
  const propsToRender = { ...props };
  const newUiSchema = { ...(props.uiSchema || {}) };

  if (!newUiSchema.classNames) {
    newUiSchema.classNames = '';
  }
  if (props.name) {
    newUiSchema.classNames += ` field-id-${props.name}`;
  }
  if (props.uiSchema && props.uiSchema['ui:type']) {
    newUiSchema.classNames += ` field-ui-type-${props.uiSchema['ui:type']}`;
  }

  if (
    props.uiSchema &&
    props.uiSchema['ui:description'] &&
    props.uiSchema['ui:enableMarkdownInDescription'] &&
    typeof props.uiSchema['ui:description'] === 'string'
  ) {
    newUiSchema['ui:description'] = (
      <Markdown options={{ disableParsingRawHTML: true }}>
        {props.uiSchema['ui:description']}
      </Markdown>
    );
  }

  return <SchemaField {...{ ...propsToRender, uiSchema: newUiSchema }} />;
};

CustomSchemaField.propTypes = {
  uiSchema: PropTypes.shape({
    'ui:type': PropTypes.string,
    'ui:description': PropTypes.string,
    'ui:enableMarkdownInDescription': PropTypes.bool,
  }),
  name: PropTypes.string,
};

CustomSchemaField.defaultProps = {
  uiSchema: {},
  name: '',
};

const sectionFields = {
  SchemaField: CustomSchemaField,
  TitleField: CustomTitleField,
};

const allFields = { ...BaseFields, ...sectionFields };
const allWidgets = { ...BaseWidgets };

const Form = ({
  fields,
  widgets,
  FieldTemplate,
  formRef,
  onSubmit,
  onError,
  ...props
}) => {
  function handleSubmit(formData, ...args) {
    if (onSubmit) {
      onSubmit(formData, ...args);
    }
  }

  function handleError(errors) {
    if (onError) {
      onError(errors);
    }

    if (errors && errors.length > 0) {
      setTimeout(() => {
        const errorElement = document.querySelector('.has-error');

        if (errorElement) {
          const input = errorElement.querySelector('input, select, textarea');
          if (input) {
            input.focus();
          }

          const yPosition = errorElement.getBoundingClientRect().top + (window.scrollY - 100);
          window.scrollTo({
            top: yPosition,
            behavior: 'smooth',
          });
        }
      }, 300);
    }
  }

  const formContext = {
    displayMode: props.uiSchema['ui:displayMode'],
    ...(props.formContext || {}),
  };

  return (
    <div id="ui-kit-jsonschema-form">
      <OriginalForm
        {...props}
        className={`ant-form ant-form-horizontal ${props.uiSchema['ui:displayMode']}`}
        ref={formRef}
        fields={allFields}
        widgets={allWidgets}
        FieldTemplate={FieldTemplate || BaseFieldTemplate}
        ObjectFieldTemplate={CustomObjectFieldTemplate}
        onSubmit={handleSubmit}
        onError={handleError}
        formContext={formContext}
      />
    </div>
  );
};

Form.propTypes = {
  fields: PropTypes.object,
  widgets: PropTypes.object,
  FieldTemplate: PropTypes.func,
  formRef: PropTypes.object,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  uiSchema: PropTypes.object,
  formContext: PropTypes.object,
};

Form.defaultProps = {
  fields: {},
  widgets: {},
  FieldTemplate: null,
  formRef: null,
  onSubmit: null,
  onError: null,
  uiSchema: {},
  formContext: {},
};

export { getPages, isFormPaginated, isFormChatUI, getAllElementKeys };

export default Form;
